import React from 'react';

import { Checkbox, Dropdown, Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowDown, ArrowsSort } from '@sravni/react-icons';

import { DEFAULT_FILTERS, FILTER_NAMES } from '../../../../constants/reviews';
import { createReviewFilterParam, getSelectOptions } from '../../../../helpers/reviews';
import { IListHeaderProps } from '../../index';
import styles from '../../reviews-list-header.module.scss';

interface IProps extends Pick<IListHeaderProps, 'filters' | 'currentServerFilters' | 'typePage' | 'handleChange'> {
  isMobile?: boolean;
  isPopup?: boolean;
}

export const Sort: React.FC<IProps> = ({
  isMobile,
  filters,
  currentServerFilters,
  typePage,
  handleChange,
  isPopup,
}) => {
  const reviewFilterParam = createReviewFilterParam('reviewOrder', currentServerFilters);

  const sortOptions = getSelectOptions(reviewFilterParam, typePage);

  const defaultSortValue = sortOptions.find((item) => item.value === DEFAULT_FILTERS[FILTER_NAMES.ORDER]);

  const sortValue = sortOptions.find((item) => item.value === filters[FILTER_NAMES.ORDER]) ?? defaultSortValue;

  const handleChangeSort = (value) => {
    handleChange(value, FILTER_NAMES.ORDER);
  };

  if (isPopup) {
    return (
      <Space direction={'vertical'} className={'h-mb-32'} size={16}>
        <Typography.Text size={16} strong>
          Показывать самые
        </Typography.Text>
        {sortOptions.map((item, i) => (
          <Checkbox
            key={`filter-item-${i}`}
            className={styles.mobileCheckbox}
            checked={sortValue?.value === item.value}
            onClick={() => handleChangeSort(item.value)}
          >
            {item.label}
          </Checkbox>
        ))}
      </Space>
    );
  }

  return (
    <Dropdown options={sortOptions} value={sortValue?.value} onChange={handleChangeSort} optionsSort={false}>
      <div className={styles.dropdownButton}>
        <Icon icon={<ArrowsSort />} />
        {isMobile ? sortValue?.label : `Самые ${sortValue?.label.toLowerCase()}`}
        <Icon icon={<ArrowDown />} className={styles.dropdownButtonIcon} />
      </div>
    </Dropdown>
  );
};
